var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fieldItem)?_c('div',[_c('component-image',{attrs:{"galleryList":JSON.parse(_vm.fieldItem.optionField),"fieldLabel":_vm.languageSelect === 0 ? _vm.fieldItem.fieldName : _vm.fieldItem.fieldNameEn,"fieldId":_vm.fieldItem.fieldId,"languageSelect":_vm.languageSelect},on:{"select-theme":_vm.handleImageSelect}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291a31d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Booking/ComponentImageCalendar.vue
// module id = null
// module chunks = 